/* eslint-disable import/prefer-default-export */
export const auditMissionEditFormSelector = (state) =>
  state.forms.audit_mission.edit
